import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SearchReferralService } from '@pg-app/partner/search-referral/services/search-referral.service';
import { environment } from '@pg-env/environment';
import { format } from 'date-fns';
import { ToastrService } from 'ngx-toastr';
import { TableCellTypes } from '@nttp/enum/table-cell-type-enum';

@Component({
  selector: 'np-search-referral',
  templateUrl: './search-referral.component.html',
  styleUrls: ['./search-referral.component.scss']
})
export class SearchReferralComponent implements OnInit {
  public rows: Array<any> = [];
  public columns = [
      {
        title: 'Client name',
        name: 'clientName',
        width: '250px',
      },
      {
        title: 'Sales person',
        name: 'salesPerson',
        width: '250px',
      },
      {
        title: 'Account open',
        name: 'accountOpen',
        type: TableCellTypes.Date,
        width: '150px',
      },
      {
        title: 'Date referred',
        name: 'dateReferred',
        sort: 'desc',
        type: TableCellTypes.Date,
        width: '150px',
      },
      {
        title: 'Account trade date',
        name: 'accountTradeDate',
        type: TableCellTypes.Date,
        width: '200px',
      },
      {
        title: 'Last activity',
        name: 'lastActivity',
        type: TableCellTypes.Date,
        width: '150px',
      },
      {
        title: 'Next activity',
        name: 'nextActivity',
        type: TableCellTypes.Date,
        width: '150px',
      },
      {
        title: 'Additional notes',
        name: 'notes',
        width: '250px',
      },
      {
        title: 'Referred By',
        name: 'referredBy',
        width: '200px',
      }
  ];
  totalItems = 0;
  public DATE_FORMAT_POST = 'YYYYMMDD';

  public searchForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private toasterService: ToastrService,
    private searchReferralService: SearchReferralService,
  ) { }

  ngOnInit() {
    this.searchForm = this.fb.group({
      fromDate: '',
      toDate: '',
      searchText: ''
    });

    this.getReferrals();
  }

  public getReferrals(paging = null) {
    const tableData = {
      fromDate: this.searchForm.get('fromDate').value
        ? format(this.searchForm.get('fromDate').value, this.DATE_FORMAT_POST)
        : null,
      toDate: this.searchForm.get('toDate').value
        ? format(this.searchForm.get('toDate').value, this.DATE_FORMAT_POST)
        : null,
      searchText: this.searchForm.get('searchText').value || null,
      paeSize: environment.defaultPageSize,
      pageIndex: paging ? paging.currentPage : 1,
      sortName: paging?.sortName  || 'DateReferred',
      sortType: paging?.sortName ? paging.sortType : 1,
      filters: paging?.filter && paging.filter.length > 0 ? paging.filter : null
    };

    this.searchReferralService.getReferrals(tableData).subscribe(
      res => {
        this.rows = res.leads || [];
        this.totalItems = res.pagination.totalItems;
      },
    );
  }

  public getSearchData() {

    if (new Date(this.searchForm.get('fromDate').value) > new Date(this.searchForm.get('toDate').value)) {
      this.toasterService.error(`From date should not be greater than To date`);
      return;
    }
    this.getReferrals();
  }
}
